import React from 'react';
import { TableFilters, SearchableSelect, TableFilterSelect } from '../../../design-system';
import { i18n } from '../../../i18n';
import { belongsToOptions } from '../../../services';
import { clientCategories } from '../../../const';

interface Props {
  clientId?: string;
  clientName?: string;
  category?: string;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  clientId = '',
  clientName = '',
  category = '',
  setStates,
}: Props) => {
  return (
    <TableFilters>
      <SearchableSelect
        selectedOptionLabel={clientName}
        label={i18n.t('common.client')}
        onSelect={(obj) => setStates('force', { clientId: obj.id, clientName: obj.label })}
        queryFn={() => belongsToOptions.Client('', true)}
        queryKey={['clients', 'assigned-clients']}
        selectedAreasEqaul={{ key: 'id', keys: [clientId] }}
        withClearButton
      />
      <TableFilterSelect
        label={i18n.t('label.category')}
        options={clientCategories}
        value={category}
        onChange={(e) => setStates('force', { category: e.target.value })}
      />
    </TableFilters>
  );
};
